import React from 'react';
import EventDescriptionWrapper from '~shared/components/react/EventDescription/EventDescriptionWrapper';
import {default as EventDescriptionDefault} from '~shared/components/react/EventDescription/EventDescription';
import PropTypes from 'prop-types';

/**
 * This Component is meant to streamline the selecting the which EventDescription component is
 * used. The difference between EventDescriptionDefault & EventDescriptionWrapper is that
 * EventDescriptionWrapper will subscribe for websockets and update the scoreboard.
 * We want to eventually remove EventDescriptionWrapper in favor of using a common data store
 * and having that hydrate the scoreboard.
 *
 * @param {object} props props to be passed through to component.
 * @returns {EventDescriptionWrapper|EventDescription} selected componet.
 */
const EventDescription = (props) => {
    const {
        forceNoWrapper = false,
        ...remainingProps
    } = props;

    const Component = !props.event?.inplay || forceNoWrapper
        ? EventDescriptionDefault
        : EventDescriptionWrapper;

    return <Component {...remainingProps} />;
};

EventDescription.propTypes = {
    event: PropTypes.object.isRequired,
    forceNoWrapper: PropTypes.bool,
};

export default EventDescription;
